import { DateTime } from "luxon";

import { RequestData } from "~utils";

type RequestViewState = {
  hasSpecialEducation: boolean;
  hasMissingSkillBuilders: boolean;
  hasLanguageRequirement: boolean;
  isDisinterestedEnabled: boolean;
  canCollectArrivalTime: boolean;
  showArriveAsapAlert: boolean;
  showFinalFillAlert: boolean;
  showArrivalTime: boolean;
  isPast: boolean;
  hasFeedback: boolean;
  isRequirementMissing: boolean;
  showLMCAcknowledgement: boolean;
};

export function getRequestViewState(request: RequestData): RequestViewState {
  const hasSpecialEducation = request.subjects?.includes("SPED") ?? false;
  const hasMissingSkillBuilders = (request.missingSkillbuilderAttrs?.length ?? 0) > 0;
  const hasLanguageRequirement = (request.bilingualRequirements?.length ?? 0) > 0;
  const isDisinterestedEnabled = !request.hasFitFeedback;

  const canCollectArrivalTime = request.action === "ACTION_SUB_CAN_SIGN_UP_WITH_ETA";

  const minutesTillStart = DateTime.fromISO(
    request.latestAcceptableStart || request.startDate,
  ).diffNow("minute").minutes;

  const showLMCAcknowledgement = minutesTillStart < 60 * 24;

  const showArriveAsapAlert = canCollectArrivalTime && minutesTillStart >= 60;
  const showFinalFillAlert = canCollectArrivalTime && minutesTillStart < 60;
  const showArrivalTime = request.status === "STATUS_CONFIRMED" && !!request.subArrivalTime;

  const isPast = request.status === "STATUS_COMPLETED";
  const hasFeedback = !!request.schoolFeedback;
  const isRequirementMissing =
    !!request.hasMissingRequirements?.credentialMissing ||
    !!request.hasMissingRequirements?.mandatoryRequirementsMissing;

  return {
    hasSpecialEducation,
    hasMissingSkillBuilders,
    hasLanguageRequirement,
    isDisinterestedEnabled,
    canCollectArrivalTime,
    showArriveAsapAlert,
    showFinalFillAlert,
    showArrivalTime,
    isPast,
    hasFeedback,
    isRequirementMissing,
    showLMCAcknowledgement,
  };
}
